export default __webpack_public_path__ + "static/media/cpv_33_medical.f49c733a.svg";